// 按钮组件
<template>
<div class='u-btn c-main'>
  <button ref="mybutton"
:disabled="disabled"
@click.prevent="onClick" >{{tip}}</button>
  <div v-show="showLoading" class='btn_mask'>
    <div class="btn_loading">
      <i :class="loading_clazz"></i>
    </div>
  </div>
</div>
</template>

<script>
/**
 * 按钮状态
 * enable loading counting
*/
export default {
  name: 'urs-button',
  props: {
    enableTip: {
      type: String,
      default: '下一步'
    },
    countingTip: {
      type: String,
      default: '[count]s'
    },
    defaultState: {
      type: String,
      default: 'enable'
    },
    enableLoading: {
      type: Boolean,
      default: true
    },
    loading_clazz: {
      type: String,
      default: 'i-icon i-icon-loading'
    },
    count: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      state: this.defaultState,
      countNum: this.count,
      disabled: false
    }
  },
  computed: {
    tip (){
      switch (this.state) {
        case 'counting':
          return this.countingTip.replace('[count]',this.countNum);
        default:
          return this.enableTip;
      }
    },
    showLoading() {
      return (this.enableLoading&&this.state=='loading');
    }
  },
  watch: {
    state(val) {
      this.disabled = !(val==='enable')
    }
  },
  beforeDestroy () {
    // @NOTE 实例销毁前清除定时器
    if(this.sto){
      window.clearTimeout(this.sto);
    }
  },
  methods: {
    setState(state,tip) {
      this.state = state;
      if(tip){
        this.tip = tip;
      }
    },
    onClick (event) {
      this.$emit('click');
    },
    countDown () {
      // 未设置间隔倒计时
      if(this.count==0){
        return;
      }
      this.setState('counting')
      this.sto = window.setTimeout(()=>{
        this.countNum --;
        if(this.countNum < 0){
          window.clearTimeout(this.sto);
          this.countNum = this.count;
          this.setState('enable')
          return;
        }
        this.countDown();
      }, 1000);
    }
  }
}
</script>

<style lang=scss>
$btn-color: #ffffff;
$btn-border: #0D70FF;
$btn-background: #0D70FF;
$btn-disabled: #cccccc;
$btn-sms-border:  #0D70FF;
$btn-sms-background: #0D70FF;
$btn-sms-color: #ffffff;

.u-btn{
    display: inline-block;
    vertical-align: top;
    position:relative;
    -moz-user-select: -moz-none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    /*
        Introduced in IE 10.
        See http://ie.microsoft.com/testdrive/HTML5/msUserSelect/
    */
    -ms-user-select: none;
    user-select: none;
    >button{
        width: 340px;
        height: 44px;
        line-height: 44px;
        border-radius: 2px;
        text-align: center;
        font-size: 18px;
        cursor: pointer;
        background-color: $btn-background;
        color: $btn-color;

        &.z-dis{
            background-color: $btn-disabled;
        }
    }
    .btn_mask{
        position:absolute;
        width:100%;
        height:100%;
        border-radius: 2px;
        top:0;
        background:#000;-moz-opacity:0.5;-khtml-opacity:0.5;filter:alpha(opacity = 50);
        opacity:0.5;
    }
    .btn_loading{
        margin-top: 13px;
        text-align: center;
    }
}
</style>




// WEBPACK FOOTER //
// Button.vue?380e7bc9